import { colors } from '@microfrontends/react-components'
import styled from 'styled-components'

export const BannerTypeBContainer = styled.div`
    border-radius: 12px;
    background-color: ${colors.neutral[99]};
    padding: 16px;
    display: flex;
`

export const ImageWrapper = styled.div`
    width: 82px;
    height: 60px;
    position: relative;
    margin-right: 16px;
`

export const ContentAction = styled.div`
    display: flex;
`

export const Content = styled.div``

export const Action = styled.div``
